import React, { Component } from "react";
import _ from 'lodash';
import AuditorScreen from '../DynamicForm/AuditorScreen'
import {Modal} from 'react-bootstrap';
export default class DoubleScreen  extends Component {
  render(){
    let fieldValue = _.cloneDeep(this.props.object)
    let auditorJson = {'templateValue':this.props.object.auditFormWithoutFeedback}
    let arrayobj=[];
    delete fieldValue.auditFormWithoutFeedback
    delete fieldValue.id
    arrayobj.push(
      {'label':'Agent Name', 'value': fieldValue.agentName},
      {'label':'Skill Set', 'value': fieldValue.skillSetName},
      {'label':'Tenure', 'value': fieldValue.tenure},
      {'label':'TL Name', 'value': fieldValue.tlName},
      {'label':'Agent Category', 'value': fieldValue.agentCategory},
      {'label':'Mobile number', 'value': fieldValue.msisdn},
      {'label':'Interaction Date', 'value': fieldValue.callDate},
      {'label':'Region', 'value': fieldValue.regionName},
      {'label':'Center', 'value': fieldValue.centerName},
      {'label':'Client', 'value': fieldValue.clientName}, 
      {'label':'Process', 'value': fieldValue.processName},
      {'label':'Case Type', 'value': fieldValue.caseType},
      {'label':'Call Sub Type1', 'value': fieldValue.callSubType1},
      {'label':'Case Sub Type2', 'value': fieldValue.callSubType2},
      {'label':'Case Sub Type3', 'value': fieldValue.callSubType3},
      {'label':'Case Sub Type4', 'value': fieldValue.callSubType4})
    return(
      <Modal
      show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w clientrecordxl"
      size="xl"
      backdrop='static'            
      keyboard={false}
     //aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
      <Modal.Title id="example-custom-modal-styling-title">
        Evaluation Form For - {this.props.title}
      </Modal.Title>
      </Modal.Header>
      <Modal.Body><AuditorScreen auditorJson={auditorJson} fieldValue = {arrayobj}
        loginUserName={this.props.loginUserName} id={this.props.object.id}
        action={this.props.action} closeModal={this.props.closeModal}  /></Modal.Body>
      </Modal>

    )
  }
}